import { useContext } from 'react';

import { SelectFlowContext } from './SelectFlowContext';

export const useSelectFlowContext = () => {
  return useContext(SelectFlowContext);
};
